import { makeAutoObservable, observable } from 'mobx';
import { ActiveSessionsType, GroupingTableType, Loadings, SearchMNNType, SelectedMNNType, TemplateType } from '../types';
import { SearchTableBodyType } from '@/features/SearchControl/hooks/useSearchTable/types';
import { WebSocketSearchSourcesType } from '@/shared/service/wsSearch/types';


class SearchState {

  loadings: Loadings = {
    searchLoading: false,
    searchMNNLoading: false,
    restart: false,
    searchDataLoading: false,
    searchAutoLoading: false,
    searchSaveDataLoading: false,
    saveMnn: false,
    saveReportLoading: false
  };

  errorSearch: boolean = false;

  @observable searchData: SearchTableBodyType[] = [];

  @observable basketData: SearchTableBodyType[] = [];

  selectedMNN: SelectedMNNType = {} as SelectedMNNType;
  
  @observable searchMNN: SearchMNNType[] = [];

  @observable autoMNN: string[] = [];

  selectedSynonyms: Record<string, string[]> = {};

  selectedSynonymsRefresh: Record<string, string[]> = {};

  groupingTable: GroupingTableType[] = [];

  filterCount: number = 0;

  filters: string[] = [];

  selectedMnnInTable: number[] = [];

  selectedMnnInTableBasket: number[] = [];

  favoritesMnnInTable: number[] = [];

  webSocketSessions: number = -1;

  questionsMnnInTable: Record<number, boolean> = {};

  activeSession: number | null = null; 

  activeSearchSessions: number | null = null; 

  isStartUpdate: boolean = false;

  needUpdated: {
    isNeed: boolean;
    id: number;
    type: string;
  } | null = null;

  templates: TemplateType[] = [];

  @observable activeSessions: ActiveSessionsType[] = [];

  searchStatus: WebSocketSearchSourcesType | null = null;

  constructor() {
    makeAutoObservable(this); 
  }
}

export const searchStateStore = new SearchState();
export type SearchStateStore = typeof searchStateStore;
